// src/pages/Contact.js
import React from "react";

export default function Contact() {
  return (
    <div className="container page">
      <div className="contact-grid">
        <div>
          <h1>Let’s talk about your next move</h1>
          <p>
            Tell us a bit about your next move and we’ll reach out with next steps — 
            pricing, timelines, and strategy included. No spam, no pressure.
          </p>

          {/* CONTACT FORM */}
          <form
            action="https://formspree.io/f/xyzvkewl"
            method="POST"
            className="card form-card"
          >
            {/* Hidden subject line for the email */}
            <input
              type="hidden"
              name="_subject"
              value="New lead from Platinum Palm Properties"
            />

            <div className="form-row">
  <div className="form-field">
    <label htmlFor="name">Name</label>
    <input
      type="text"
      id="name"
      name="name"
      required
      placeholder="Your full name"
    />
  </div>

  <div className="form-field">
    <label htmlFor="phone">Phone</label>
    <input
      type="tel"
      id="phone"
      name="phone"
      required
      placeholder="(555) 555-5555"
    />
  </div>
</div>

<div className="form-row">
  <div className="form-field">
    <label htmlFor="email">Email</label>
    <input
      type="email"
      id="email"
      name="email"
      required
      placeholder="you@example.com"
    />
  </div>

  <div className="form-field">
    <label htmlFor="intent">Are you buying, selling, or both?</label>
    <select id="intent" name="intent">
      <option>Buying</option>
      <option>Selling</option>
      <option>Buying & Selling</option>
      <option>Just exploring</option>
    </select>
  </div>
</div>


            <div className="form-field">
              <label htmlFor="message">How can we help?</label>
              <textarea
                id="message"
                name="message"
                rows={4}
                placeholder="Tell us your goals, timeline, price range, etc."
                required
              />
            </div>

            <button type="submit" className="btn btn-primary">
              Send Message
            </button>
          </form>
        </div>

        <aside className="card contact-card">
          <h2>Office & contact details</h2>

          <p>
            Phone:&nbsp;
            <a href="tel:941-718-8317" className="highlight">
              941-718-8317
            </a>
          </p>

          <p>
            Email:&nbsp;
            <a href="mailto:info@platinumpalmproperties.com" className="highlight">
              info@platinumpalmproperties.com
            </a>
          </p>

          <p className="page-footnote">
            Licensed Florida real estate brokerage. Equal Housing Opportunity.
          </p>
        </aside>
      </div>
    </div>
  );
}
